export default __webpack_public_path__ + "static/media/private.1b97e161.svg";